module.exports = __webpack_public_path__ + "static/media/icon-email.d64af938.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-email.svg
// module id = ./src/assets/images/icon-email.svg
// module chunks = 6